/* House of Whiskerton - Shopify theme interactions. Vanilla JS, no deps. */
(function () {
  "use strict";

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var search = (window.location && window.location.search || "").toLowerCase();
  var paidPath = /(?:\?|&)(utm_medium=paid|utm_source=meta|utm_source=facebook|utm_source=instagram|hw_mode=buy)(?:&|$)/.test(search);

  var MONEY_FORMAT = window.HW_MONEY_FORMAT || "${{amount}}";
  function formatMoney(cents, format) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var f = format || MONEY_FORMAT;
    function defaultTo(n, d) { return n == null ? d : n; }
    function thousands(num, precision, thousand, decimal) {
      precision = defaultTo(precision, 2);
      thousand = defaultTo(thousand, ",");
      decimal = defaultTo(decimal, ".");
      if (isNaN(num) || num == null) return 0;
      num = (num / 100).toFixed(precision);
      var parts = num.split(".");
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousand);
      var centsPart = parts[1] ? decimal + parts[1] : "";
      return dollars + centsPart;
    }
    switch (f.match(placeholderRegex)[1]) {
      case "amount": value = thousands(cents, 2); break;
      case "amount_no_decimals": value = thousands(cents, 0); break;
      case "amount_with_comma_separator": value = thousands(cents, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": value = thousands(cents, 0, ".", ","); break;
      default: value = thousands(cents, 2);
    }
    return f.replace(placeholderRegex, value);
  }

  $$("[data-year]").forEach(function (el) { el.textContent = new Date().getFullYear(); });

  var toast = $("#toast");
  var toastTimer;
  function showToast(html) {
    if (!toast) return;
    toast.innerHTML = html;
    toast.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove("show"); }, 4200);
  }

  var announce = $("#announce");
  if (announce) {
    if (sessionStorage.getItem("hw_announce") === "closed") announce.style.display = "none";
    var ac = $(".close", announce);
    if (ac) ac.addEventListener("click", function () {
      announce.style.display = "none";
      sessionStorage.setItem("hw_announce", "closed");
    });
    if (paidPath) announce.style.display = "none";
  }

  var burger = $(".burger");
  var drawer = $("#drawer");
  var scrim = $("#scrim");
  var cartDrawer = $("#cartDrawer");
  var cartScrim = $("#cartScrim");
  var cartBody = $("#cartDrawerBody");
  var cartStatus = $("#cartDrawerStatus");
  var cartFooter = $("#cartDrawerFooter");
  var cartSubtotal = $("#cartDrawerSubtotal");
  var cartCountEls = $$("[data-cart-count]");
  var cartOpenEls = $$("[data-cart-open]");
  var cartCloseEls = $$("[data-cart-close]");
  var cartPending = false;

  function syncPageLock() {
    var navOpen = drawer && drawer.classList.contains("open");
    var cartOpen = cartDrawer && cartDrawer.classList.contains("open");
    document.body.style.overflow = (navOpen || cartOpen) ? "hidden" : "";
  }

  function toggleNav(open) {
    if (!drawer) return;
    if (open) toggleCart(false);
    drawer.classList.toggle("open", open);
    if (scrim) scrim.classList.toggle("open", open);
    if (burger) {
      burger.classList.toggle("open", open);
      burger.setAttribute("aria-expanded", open ? "true" : "false");
    }
    syncPageLock();
  }

  function toggleCart(open) {
    if (!cartDrawer || !cartScrim) return;
    if (open) toggleNav(false);
    cartDrawer.classList.toggle("open", open);
    cartScrim.classList.toggle("open", open);
    cartDrawer.setAttribute("aria-hidden", open ? "false" : "true");
    cartOpenEls.forEach(function (el) { el.setAttribute("aria-expanded", open ? "true" : "false"); });
    syncPageLock();
  }

  if (burger) burger.addEventListener("click", function () {
    toggleNav(!drawer.classList.contains("open"));
  });
  if (scrim) scrim.addEventListener("click", function () { toggleNav(false); });
  $$("#drawer a").forEach(function (a) { a.addEventListener("click", function () { toggleNav(false); }); });

  $$(".acc").forEach(function (acc) {
    var q = $(".acc__q", acc);
    var a = $(".acc__a", acc);
    if (!q || !a) return;
    q.addEventListener("click", function () {
      var open = acc.classList.toggle("open");
      a.style.maxHeight = open ? a.scrollHeight + "px" : 0;
    });
  });

  $$(".ba").forEach(function (ba) {
    var before = $(".ba__before", ba);
    var handle = $(".ba__handle", ba);
    var dragging = false;
    if (!before || !handle) return;
    function set(x) {
      var r = ba.getBoundingClientRect();
      var p = ((x - r.left) / r.width) * 100;
      p = Math.max(4, Math.min(96, p));
      before.style.width = p + "%";
      handle.style.left = p + "%";
    }
    function move(e) {
      if (!dragging) return;
      set(e.touches ? e.touches[0].clientX : e.clientX);
    }
    ba.addEventListener("mousedown", function (e) { dragging = true; set(e.clientX); });
    ba.addEventListener("touchstart", function (e) { dragging = true; set(e.touches[0].clientX); }, { passive: true });
    window.addEventListener("mousemove", move);
    window.addEventListener("touchmove", move, { passive: true });
    window.addEventListener("mouseup", function () { dragging = false; });
    window.addEventListener("touchend", function () { dragging = false; });
  });

  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add("in");
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    $$(".reveal").forEach(function (el) { io.observe(el); });
  } else {
    $$(".reveal").forEach(function (el) { el.classList.add("in"); });
  }

  (function () {
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    if (window.matchMedia && window.matchMedia("(pointer: coarse)").matches) return;
    $$("[data-tilt-card]").forEach(function (card) {
      var limit = Number(card.getAttribute("data-tilt-limit") || 7);
      function reset() {
        card.classList.remove("is-tilting");
        card.style.setProperty("--tilt-x", "0deg");
        card.style.setProperty("--tilt-y", "0deg");
        card.style.setProperty("--tilt-z", "0px");
      }
      card.addEventListener("mousemove", function (e) {
        var rect = card.getBoundingClientRect();
        var px = (e.clientX - rect.left) / rect.width;
        var py = (e.clientY - rect.top) / rect.height;
        var tiltY = (px - 0.5) * (limit * 2);
        var tiltX = (0.5 - py) * (limit * 2);
        card.classList.add("is-tilting");
        card.style.setProperty("--tilt-x", tiltX.toFixed(2) + "deg");
        card.style.setProperty("--tilt-y", tiltY.toFixed(2) + "deg");
        card.style.setProperty("--tilt-z", "-4px");
      });
      card.addEventListener("mouseleave", reset);
      card.addEventListener("blur", reset, true);
    });
  })();

  function setCartCount(count) {
    cartCountEls.forEach(function (el) { el.textContent = count; });
  }
  function setCartStatus(text) {
    if (cartStatus) cartStatus.textContent = text;
  }
  function cartRootPath() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : "/";
  }
  function fetchCartData() {
    return fetch(cartRootPath() + "cart.js", { headers: { "Accept": "application/json" } }).then(function (response) {
      if (!response.ok) throw new Error("Cart request failed");
      return response.json();
    });
  }
  function renderCartDrawer(cart) {
    if (!cartBody || !cartFooter || !cartSubtotal) return;
    setCartCount(cart.item_count || 0);
    cartSubtotal.textContent = formatMoney(cart.total_price || 0);
    if (!cart.items || !cart.items.length) {
      setCartStatus("Your cart is empty right now.");
      cartFooter.hidden = true;
      cartBody.innerHTML = [
        '<div class="cart-drawer__empty">',
        '<strong>No portraits waiting yet</strong>',
        '<p>Start with the flagship royal portrait and we will help you turn one favourite photo into a premium piece worth displaying.</p>',
        '<a href="/products/custom-pet-portrait" class="btn btn--lg">Create My Portrait <span class="arr">-></span></a>',
        '</div>'
      ].join("");
      return;
    }

    setCartStatus("Proof-first custom portraits, all in one place.");
    cartFooter.hidden = false;
    cartBody.innerHTML = cart.items.map(function (item) {
      var props = "";
      Object.keys(item.properties || {}).forEach(function (key) {
        var value = item.properties[key];
        if (value == null || value === "") return;
        if (String(value).indexOf("/uploads/") !== -1) props += '<div>' + key + ': <a href="' + value + '" style="color:var(--gold-deep);text-decoration:underline;">uploaded photo</a></div>';
        else props += '<div>' + key + ': ' + value + '</div>';
      });
      var variant = item.variant_title && item.variant_title !== "Default Title" ? '<div class="cart-drawer__variant">' + item.variant_title + '</div>' : "";
      var image = item.image ? '<img src="' + item.image + '" alt="' + (item.product_title || item.title) + '" loading="lazy" width="176" height="220">' : "";
      return [
        '<article class="cart-drawer__item">',
        '<a class="cart-drawer__thumb" href="', item.url, '">', image, '</a>',
        '<div>',
        '<a class="cart-drawer__title" href="', item.url, '">', item.product_title || item.title, '</a>',
        variant,
        props ? '<div class="cart-drawer__properties">' + props + '</div>' : '',
        '<div class="cart-drawer__row">',
        '<div class="cart-drawer__qty" data-cart-key="', item.key, '">',
        '<button type="button" data-cart-qty="-1" aria-label="Decrease quantity">-</button>',
        '<span>', item.quantity, '</span>',
        '<button type="button" data-cart-qty="1" aria-label="Increase quantity">+</button>',
        '</div>',
        '<span class="cart-drawer__line-price">', formatMoney(item.final_line_price), '</span>',
        '</div>',
        '<button type="button" class="cart-drawer__remove" data-cart-remove="', item.key, '">Remove</button>',
        '</div>',
        '</article>'
      ].join("");
    }).join("");
  }
  function refreshCartDrawer(openAfter, expectedCount, retriesLeft) {
    if (!cartBody) return Promise.resolve();
    retriesLeft = typeof retriesLeft === "number" ? retriesLeft : 2;
    cartBody.innerHTML = '<div class="cart-drawer__loading">Refreshing your cart</div>';
    setCartStatus("Loading your cart...");
    return fetchCartData().then(function (cart) {
      if (typeof expectedCount === "number" && cart.item_count < expectedCount && retriesLeft > 0) {
        return new Promise(function (resolve) {
          setTimeout(function () {
            resolve(refreshCartDrawer(openAfter, expectedCount, retriesLeft - 1));
          }, 180);
        });
      }
      renderCartDrawer(cart);
      if (openAfter) toggleCart(true);
      return cart;
    }).catch(function () {
      setCartStatus("We could not refresh the cart just now.");
      cartFooter && (cartFooter.hidden = true);
      cartBody.innerHTML = '<div class="cart-drawer__empty"><strong>Cart unavailable</strong><p>Please try again in a moment, or use the full cart page if the issue persists.</p><a href="/cart" class="btn btn--lg">View cart <span class="arr">-></span></a></div>';
    });
  }
  function changeCartLine(key, quantity) {
    if (cartPending) return;
    cartPending = true;
    setCartStatus("Updating your cart...");
    return fetch(cartRootPath() + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (response) {
      if (!response.ok) throw new Error("Cart update failed");
      return response.json();
    }).then(function (cart) {
      renderCartDrawer(cart);
      showToast("<b>Cart updated</b><p>Your cart has been refreshed.</p>");
    }).catch(function () {
      showToast("<b>Cart update failed</b><p>Please try that again.</p>");
      return refreshCartDrawer(false);
    }).finally(function () {
      cartPending = false;
    });
  }

  cartOpenEls.forEach(function (el) {
    el.addEventListener("click", function () { refreshCartDrawer(true); });
  });
  cartCloseEls.forEach(function (el) {
    el.addEventListener("click", function () { toggleCart(false); });
  });
  if (cartScrim) cartScrim.addEventListener("click", function () { toggleCart(false); });
  if (cartBody) {
    cartBody.addEventListener("click", function (e) {
      var qtyBtn = e.target.closest("[data-cart-qty]");
      if (qtyBtn) {
        var qtyWrap = qtyBtn.closest("[data-cart-key]");
        if (!qtyWrap) return;
        var current = Number($("span", qtyWrap).textContent || "1");
        var nextQty = Math.max(0, current + Number(qtyBtn.getAttribute("data-cart-qty") || "0"));
        changeCartLine(qtyWrap.getAttribute("data-cart-key"), nextQty);
        return;
      }
      var removeBtn = e.target.closest("[data-cart-remove]");
      if (removeBtn) changeCartLine(removeBtn.getAttribute("data-cart-remove"), 0);
    });
  }
  refreshCartDrawer(false);

  var root = $("#MainProduct");
  if (root) {
    if (paidPath) {
      document.documentElement.classList.add("hw-paid-path");
      root.setAttribute("data-paid-path", "true");
      var sub = $(".buybox .sub", root);
      if (sub) sub.textContent = "Order today, then approve your proof before we print. AI-crafted, human-reviewed, and backed by the Love-It Guarantee.";
      var ctaWrap = $(".buybox__cta", root);
      if (ctaWrap && !ctaWrap.querySelector(".field-note--paid")) {
        var paidNote = document.createElement("p");
        paidNote.className = "field-note field-note--paid";
        paidNote.style.textAlign = "center";
        paidNote.textContent = "This paid-traffic page is buy-first on purpose. Your proof still arrives before anything prints.";
        ctaWrap.appendChild(paidNote);
      }
      var uploadTitle = $(".upload__title", root);
      var uploadHint = $(".upload__hint", root);
      if (uploadTitle) uploadTitle.textContent = "Upload your pet photo now or after checkout";
      if (uploadHint) uploadHint.textContent = "Fastest path: add to cart now, then send the photo if you are ready.";
    }

    var dataEl = $("#ProductJson", root);
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var form = $("#product-form", root);
    var idInput = $("#variantId", root);
    var priceEl = $("#price", root);
    var compareEl = $("#price-compare", root);
    var saveEl = $("#price-save", root);
    var ctaBtn = $("#mainCta", root);
    var barPrice = $("#barPrice");
    var barBtn = $("#barCta");
    var optionGroups = $$("[data-option-index]", root);
    var upload = $("#upload", root);
    var fileInput = $("#fileInput", root);
    var hasFile = false;

    function selectedOptions() {
      return optionGroups.map(function (g) {
        var checked = $("input:checked", g);
        return checked ? checked.value : null;
      });
    }
    function findVariant(opts) {
      return variants.find(function (v) {
        return opts.every(function (val, i) { return val == null || v.options[i] === val; });
      });
    }
    function updateLabels() {
      optionGroups.forEach(function (g) {
        var checked = $("input:checked", g);
        var valEl = $(".val", g);
        $$(".pill", g).forEach(function (p) { p.classList.toggle("active", p.contains(checked)); });
        if (checked && valEl) valEl.textContent = checked.value;
      });
    }
    function render() {
      updateLabels();
      var v = findVariant(selectedOptions());
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.style.display = "";
          compareEl.textContent = formatMoney(v.compare_at_price);
          if (saveEl) {
            saveEl.style.display = "";
            saveEl.textContent = "Save " + formatMoney(v.compare_at_price - v.price);
          }
        } else {
          compareEl.style.display = "none";
          if (saveEl) saveEl.style.display = "none";
        }
      }
      if (barPrice && barPrice.childNodes[0]) barPrice.childNodes[0].nodeValue = formatMoney(v.price);
      if (ctaBtn) {
        if (v.available) {
          ctaBtn.disabled = false;
          ctaBtn.querySelector(".btn-label") && (ctaBtn.querySelector(".btn-label").textContent = "Add to cart - " + formatMoney(v.price));
        } else {
          ctaBtn.disabled = true;
          ctaBtn.querySelector(".btn-label") && (ctaBtn.querySelector(".btn-label").textContent = "Sold out");
        }
      }
    }
    optionGroups.forEach(function (g) { g.addEventListener("change", render); });

    if (upload && fileInput) {
      var prev = $(".upload__preview img", upload);
      var fname = $(".fname", upload);
      function setFile(file) {
        if (!file) return;
        hasFile = true;
        upload.classList.add("has-file");
        if (fname) fname.textContent = file.name;
        if (prev && file.type.indexOf("image/") === 0) prev.src = URL.createObjectURL(file);
      }
      fileInput.addEventListener("change", function (e) { setFile(e.target.files[0]); });
      ["dragover", "dragenter"].forEach(function (ev) {
        upload.addEventListener(ev, function (e) {
          e.preventDefault();
          upload.classList.add("drag");
        });
      });
      ["dragleave", "drop"].forEach(function (ev) {
        upload.addEventListener(ev, function (e) {
          e.preventDefault();
          upload.classList.remove("drag");
        });
      });
      upload.addEventListener("drop", function (e) {
        if (e.dataTransfer.files[0]) {
          fileInput.files = e.dataTransfer.files;
          setFile(e.dataTransfer.files[0]);
        }
      });
      var clr = $(".upload__clear", upload);
      if (clr) clr.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        hasFile = false;
        fileInput.value = "";
        upload.classList.remove("has-file");
      });
    }

    if (barBtn && form) {
      barBtn.addEventListener("click", function () {
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      });
    }
    var bar = $("#buybar");
    if (bar && ctaBtn && "IntersectionObserver" in window) {
      new IntersectionObserver(function (e) {
        bar.classList.toggle("show", !e[0].isIntersecting);
      }, { threshold: 0 }).observe(ctaBtn);
    }

    if (paidPath) {
      $$("a[href*='/pages/free-preview']").forEach(function (el) { el.style.display = "none"; });
      $$(".cta-or", root).forEach(function (el) { el.style.display = "none"; });
      $$(".pdp-spec__item", document).forEach(function (el) {
        if (/free preview first/i.test(el.innerText || "")) el.style.display = "none";
      });
    }

    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        if (cartPending) return;
        if (!paidPath && fileInput && !hasFile) {
          showToast("<b>One thing first</b><p>Upload a photo of your pet so we can start the portrait.</p>");
          if (upload) upload.scrollIntoView({ behavior: "smooth", block: "center" });
          return;
        }

        cartPending = true;
        if (ctaBtn) {
          ctaBtn.disabled = true;
          ctaBtn.querySelector(".btn-label") && (ctaBtn.querySelector(".btn-label").textContent = "Adding to cart...");
        }

        var formData = new FormData(form);
        var currentCount = Number((cartCountEls[0] && cartCountEls[0].textContent) || "0");
        var expectedCount = currentCount + 1;
        fetch(cartRootPath() + "cart/add.js", {
          method: "POST",
          headers: { "Accept": "application/json" },
          body: formData
        }).then(function (response) {
          if (!response.ok) throw new Error("Add to cart failed");
          return response.json();
        }).then(function () {
          var bumpEl = $("#bump", root);
          if (bumpEl && bumpEl.checked && bumpEl.dataset.addonVariant) {
            expectedCount += 1;
            return fetch(cartRootPath() + "cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
              },
              body: JSON.stringify({ items: [{ id: Number(bumpEl.dataset.addonVariant), quantity: 1 }] })
            }).then(function (response) {
              if (!response.ok) throw new Error("Add-on failed");
              return response.json();
            });
          }
          return null;
        }).then(function () {
          showToast("<b>Added to cart</b><p>Your portrait is in the cart. You can still review everything before checkout.</p>");
          return refreshCartDrawer(true, expectedCount);
        }).catch(function () {
          showToast("<b>Could not add to cart</b><p>Please try again. If the problem continues, use the full cart page.</p>");
        }).finally(function () {
          cartPending = false;
          render();
        });
      });
    }

    render();
  }
})();
